function getArrayDefault(array) {
  const arr = [];
  array.forEach(element => arr.push(getDefault(element)));
  return arr;
}

function getDefault(item) {
  if (Array.isArray(item)) getArrayDefault(item);
  else {
    switch (typeof item) {
      case "string":
        return "";

      case "number":
        return 0;

      case "object":
        return clear(item);

      case "boolean":
        return false;
    }
  }
}

function clear(object) {
  if (object) {
    Object.entries(object).forEach(entry => {
      if (Array.isArray(object[entry[0]])) {
        object[entry[0]] = getArrayDefault(entry[1]);
      } else {
        object[entry[0]] = getDefault(entry[1]);
      }
    });
  }

  return object;
}

export default {
  methods: {
    resetForm(object) {
      clear(object);
    }
  }
};
